<template>
  <div>
    <div class="pt-6" v-if="recipes?.length">
      <v-data-table
        :items="recipes"
        :headers="headers"
        no-data-text="Keine Songsheets gefunden"
        :items-per-page-options="[
          { value: 5, title: '5' },
          { value: 10, title: '10' },
          { value: 25, title: '25' },
          { value: 50, title: '50' },
          { value: 100, title: '100' },
          { value: -1, title: 'Alle' },
        ]"
        items-per-page-text="Einträge pro Seite"
        :pageText="'{0}-{1} von {2}'"
      >
        <template v-slot:item.title="{ item }">
          <b class="text-primary cursor-pointer" @click="goToPage(`/recipes/${item._id}`)">{{
            item.title
          }}</b>
        </template>
        <template v-slot:item.ingredients="{ item }">
          {{ item.ingredients?.length }}
        </template>
        <template v-slot:item.updatedAt="{ item }">
          {{ getNiceDate(item.updatedAt) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon icon="mdi-pencil" color="success" @click.prevent="editRecipe(item)"></v-icon>
          <v-icon icon="mdi-trash-can" color="error" @click.prevent="deleteRecipe(item)"></v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script src="./Recipe.js"></script>
